import { TABLE_COLUMN_DEFINITIONS, TABLE_COL_NAMES } from 'src/services/consts/table-cell.const'

// Confirmation Constants

export const CONFIRMATION_NOT_REQUIRED_YEARS = 25

export const CONFIRMATION_FILTER_FIELDS = {
  search: '', // string
  dateCreatedRange: null, // '1d', '1w', '1m', '3m', 'all'
  lastConfirmationRange: null, // '1d', '1w', '1m', '3m', '1y'
}

export const CONFIRMATION_SORT_PAGINATION_FIELDS = {
  sortBy: TABLE_COL_NAMES.DATE_CREATED,
  descending: true,
  page: 1,
  rowsPerPage: 15,
}

export const DEFAULT_FILTER_SORT = {
  ...CONFIRMATION_SORT_PAGINATION_FIELDS,
  ...CONFIRMATION_FILTER_FIELDS,
}

export const LAST_CONFIRMATION_RANGE_OPTIONS = [
  { label: 'All time', value: null },
  { label: 'Last Day', value: '1d' },
  { label: 'Last Week', value: '1w' },
  { label: 'Last Month', value: '1m' },
  { label: 'Last 3 Months', value: '3m' },
  { label: 'Last Year', value: '1y' },
]

export const CREATED_DATE_RANGE_OPTIONS = [
  { label: 'All time', value: null },
  { label: 'Last Day', value: '1d' },
  { label: 'Last Week', value: '1w' },
  { label: 'Last Month', value: '1m' },
  { label: 'Last 3 Months', value: '3m' },
]

export const CONFIRMATION_TABLE_COLUMNS = [
  TABLE_COLUMN_DEFINITIONS.checkbox,
  TABLE_COLUMN_DEFINITIONS.productName,
  TABLE_COLUMN_DEFINITIONS.lastUserConfirmation,
  TABLE_COLUMN_DEFINITIONS.dateCreated,
  TABLE_COLUMN_DEFINITIONS.actions,
]
